// src/api/escalationApi.js
import apiClient from './axios';

const escalationApi = {
  getAll: async (page = 1, pageSize = 10, search = '', employee ='') => {
    const response = await apiClient.get('/escalations/', {
      params: {
        page,
        page_size: pageSize,
        search,
        employee,
      },
    });
    return response.data; // Expected: { data: [...], pagination: { count, page_size, next, previous } }
  },

  getById: async (id) => {
    const response = await apiClient.get(`/escalations/${id}/`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/escalations/', data);
    return response.data;
  },

    bulkCreate: async (data) => {
    const response = await apiClient.post('/escalations/bulk_create/', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await apiClient.patch(`/escalations/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/escalations/${id}/`);
    return id;
  },
};

export default escalationApi;